import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export const getKnmListPlanId = (state: IRootState) => state.knmList.planId;
export const getKnmListSearchValue = (state: IRootState) => state.knmList.searchValue;
export const getKnmListData = (state: IRootState) => state.knmList.data;
export const getKnmListOrder = (state: IRootState) => state.knmList.order;
export const getKnmListPage = (state: IRootState) => state.knmList.page;
export const getKnmListPageCount = (state: IRootState) => state.knmList.pageCount;
export const getKnmListTotalCount = (state: IRootState) => state.knmList.totalCount;
export const getKnmListRejected = (state: IRootState) => state.knmList.rejected;
export const getKnmListFindData = (state: IRootState) => state.knmList.findData;
